import { render, staticRenderFns } from "./AddRevenueMain.vue?vue&type=template&id=7216405a&scoped=true"
import script from "./AddRevenueMain.vue?vue&type=script&lang=js"
export * from "./AddRevenueMain.vue?vue&type=script&lang=js"
import style0 from "./AddRevenueMain.vue?vue&type=style&index=0&id=7216405a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216405a",
  null
  
)

export default component.exports